// extracted by mini-css-extract-plugin
export default {"bannerImage":"DeviceDetail_bannerImage__whCGG","mainInfo":"DeviceDetail_mainInfo__ZKdPm","deviceStatus":"DeviceDetail_deviceStatus__AuVi2"};